'use strict';

import {routingConfig} from './authorizationConfig.js';

//we load the library "search" even if we don't use it. The aim is to respect the order in the loading
//initialy, we shoud load the "visualize" library but in order to do the translation of the application
//we need to load this library after the local was get with angular


// Declare app level module which depends on filters, and services
angular.module('FlexyBeautyApp',
    ['ngResource', 'ngRoute', 'ngCookies', 'ngTouch',
        'FlexyBeautyApp.filters', 'FlexyBeautyApp.services', 'FlexyBeautyApp.directives', 'FlexyBeautyApp.controllers', 'ui.bootstrap', 'ui.bootstrap.dropdownToggle'/* load  this file only for textangular*/,
        'ui.bootstrap.dialog', 'ui.bootstrap.bindHtml', 'ui.sortable', 'angularSpinner', 'ivpusic.cookie', 'infinite-scroll', 'flow', 'ui.slider', 'textAngular', 'angular-bugsnag', 'shoppinpal.mobile-menu', 'gettext', 'tmh.dynamicLocale',
        'base64', 'anguFixedHeaderTable', 'ngSanitize', 'ngTagsInput', 'angularMoment', 'ngIdle',
    ])
    .config(['$compileProvider', '$routeProvider', '$locationProvider', '$httpProvider', '$logProvider', '$provide', 'tmhDynamicLocaleProvider', 'IdleProvider', 'Constants',
        function ($compileProvider, $routeProvider, $locationProvider, $httpProvider, $logProvider, $provide, tmhDynamicLocaleProvider, IdleProvider, Constants) {

            /* fix as angular.lowercase & angular.uppercase is removed from v1.7.x and breaking textAngular dependence */
            angular.lowercase = angular.$$lowercase;
            angular.uppercase = angular.$$uppercase;

            $compileProvider.debugInfoEnabled(false);
            $locationProvider.hashPrefix('');

            tmhDynamicLocaleProvider.localeLocationPattern('/lib/angular-i18n/angular-locale_{{locale}}.js');
            var access = routingConfig.accessLevels;
            $logProvider.debugEnabled(false);
            $routeProvider.when('/app/:domain/:ssDomain', {
                templateUrl: 'partials/app.html',
                controller: 'AppCtrl',
                access: access.user,
                reloadOnSearch: false
            });
            $routeProvider.when('/app/:domain', {
                templateUrl: 'partials/app.html',
                controller: 'AppCtrl',
                access: access.user,
                reloadOnSearch: false
            });
            $routeProvider.when('/login', {
                templateUrl: 'partials/login.html',
                controller: 'LoginCtrl',
                access: access.anon
            });
            $routeProvider.when('/register', {
                templateUrl: 'partials/register.html',
                controller: 'LoginCtrl',
                access: access.anon
            });
            $routeProvider.when('/register/model', {
                templateUrl: 'partials/register.html',
                controller: 'LoginCtrl',
                access: access.anon
            });
            $routeProvider.when('/registerTranslate', {
                templateUrl: 'partials/registerTranslate.html',
                controller: 'LoginCtrl',
                access: access.anon
            });
            $routeProvider.when('/register/:offer', {
                templateUrl: 'partials/register.html',
                controller: 'LoginCtrl',
                access: access.anon
            });
            $routeProvider.when('/register/:offer/:manager', {
                templateUrl: 'partials/register.html',
                controller: 'LoginCtrl',
                access: access.anon
            });
            $routeProvider.when('/forgotPwd/:email/:token', {
                templateUrl: 'partials/forgotPwd.html',
                controller: 'ForgotPwdCtrl',
                access: access.anon
            });
            $routeProvider.when('/404', {
                templateUrl: 'partials/404.html',
                access: access.public
            });
            $routeProvider.when('/report/:idReport/:beginDayId/:endDayId/:dashboardId/:indexReport', {
                templateUrl: 'partials/statistics/report/reportAlone.html',
                access: access.user,
            });
            /*$routeProvider.when('/dashboardSchedulerOverview/:dashboardTitle/:beginDayId/:endDayId/:dashboardId/:indexReport', {
                templateUrl:    'partials/statistics/report/overviewDashboardMail.html',
                access: access.public,
            });*/
            $routeProvider.otherwise({redirectTo: '/app/planningPos'});

            $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function (taRegisterTool, taOptions) {
                // $delegate is the taOptions we are decorating
                // register the tool with textAngular
                taRegisterTool('fontName', {
                    display: "<span class='bar-btn-dropdown dropdown'>" +
                        "<button class='btn btn-blue dropdown-toggle' type='button' ng-disabled='showHtml()' style='padding-top: 4px'><i class='fal fa-font'></i><i class='fal fa-angle-down'></i></button>" +
                        "<ul class='dropdown-menu'><li ng-repeat='o in options'><button class='btn btn-blue checked-dropdown' style='font-family: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.css)'><i ng-if='o.active' class='fal fa-check'></i >{{o.name}}</button></li></ul></span>",
                    action: function (event, font) {
                        //Ask if event is really an event.
                        if (!!event.stopPropagation) {
                            //With this, you stop the event of textAngular.
                            event.stopPropagation();
                            //Then click in the body to close the dropdown.
                            $("body").trigger("click");
                        }
                        return this.$editor().wrapSelection('fontName', font);
                    },
                    options: [
                        {name: 'Abril', css: "'Abril Fatface', cursive", size: 100},
                        {name: 'Arial', css: "Arial, Helvetica, sans-serif", size: 100},
                        {name: 'Arvo', css: "'Arvo', serif"},
                        {name: 'Comic Sans MS', css: "'comic sans ms', sans-serif", size: 95},
                        {name: 'Damion', css: "'Damion', cursive", size: 110},
                        {name: 'Droid Sans', css: "'Droid Sans', sans-serif", size: 100},
                        {name: 'Parisienne', css: "'Parisienne', cursive", size: 110},
                        {name: 'Georgia', css: 'georgia, serif', size: 100},
                        {name: 'IM Fell French', css: "'IM Fell French Canon', serif", size: 100},
                        {name: 'Josefin', css: "'Josefin Slab', serif", size: 115},
                        {name: 'Lato', css: 'Lato, sans-serif', size: 100},
                        {name: 'Lucida Su', css: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', size: 100},
                        {name: 'Open Sans', css: "'Open Sans', sans-serif", size: 100},
                        {name: 'Old Standard', css: "'Old Standard TT', serif", size: 100},
                        {name: 'Palatino', css: "'Palatino Linotype', 'Book Antiqua', Palatino, serif", size: 100},
                        {name: 'Playball', css: "'Playball', cursive ", size: 110},
                        {name: 'Pinyon Script', css: "'Pinyon Script', cursive;line-height: 1.35", size: 120},
                        {name: 'Times New Roman', css: "'Times New Roman', Times, serif", size: 100},
                        {name: 'Trebuchet MS', css: "'trebuchet ms', sans-serif", size: 100},
                        {name: 'Petit Formal S', css: "'Petit Formal Script', cursive", size: 95},
                        {name: 'PT Sans', css: "'PT Sans', sans-serif", size: 100},
                        {name: 'PT Serif', css: "'PT Serif', serif", size: 100},
                        {name: 'Tahoma', css: 'Tahoma, Geneva, sans-serif', size: 100},
                        {name: 'Tangerine', css: "'Tangerine', cursive;line-height: 1", size: 160},
                        {name: 'Verdana', css: 'Verdana, Geneva, sans-serif', size: 100},
                        {name: 'Vollkorn', css: "'Vollkorn', serif", size: 100}
                    ]
                });

                // add the button to the default toolbar definition
                taOptions.toolbar[1].push('backgroundColor', 'fontColor', 'fontName', 'fontSize');
                return taOptions;
            }]);

            // TODO ANALYSE $locationProvider.html5Mode(true);
            //$locationProvider.html5Mode(true);
            //$locationProvider.hashPrefix('!');

            //initialize get if not there
            if (!$httpProvider.defaults.headers.get)
                $httpProvider.defaults.headers.get = {};
            //disable IE ajax request caching
            //TODO
            //$httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';

            var interceptor = ['$location', '$q', function ($location, $q) {
                function success(response) {
                    return response;
                }

                function error(response) {

                    if (response.status === 401) {
                        $location.path('/login');
                        return $q.reject(response);
                    } else {
                        return $q.reject(response);
                    }
                }

                return function (promise) {
                    return promise.then(success, error);
                }
            }];

            IdleProvider.idle(Constants.IDLE_TIME_START_IN_SECONDS);
            IdleProvider.timeout(false);
        }
    ])
    .run(['$rootScope', '$location', 'Auth', '$templateCache', '$window', 'AppRedirectionFactory',
        function ($rootScope, $location, Auth, $templateCache, $window, AppRedirectionFactory) {
            Auth.init(true);
            $rootScope.$on("$routeChangeStart", function (event, next, current) {
                $rootScope.error = null;
                AppRedirectionFactory.needRedirectionAppUrl($location);
                if (!Auth.authorize(next.access)) {
                    if (Auth.isLoggedIn()) {
                        $location.path('/');
                    } else {
                        $location.path('/login');
                    }
                }
            });
            $rootScope.online = navigator.onLine;
            $window.addEventListener("offline", function () {
                if (!$rootScope.$$phase || ($rootScope.$$phase != '$apply' && $rootScope.$$phase != '$digest'))
                    $rootScope.$apply(function () {
                        $rootScope.online = false;
                    });
                else
                    $rootScope.online = false;
            }, false);
            $window.addEventListener("online", function () {
                if (!$rootScope.$$phase || ($rootScope.$$phase && $rootScope.$$phase != '$apply' && $rootScope.$$phase != '$digest'))
                    $rootScope.$apply(function () {
                        $rootScope.online = true;
                    });
                else
                    $rootScope.online = true;
            }, false);

            $rootScope.versionInterval = undefined;

        }
    ]);


angular.module('exceptionOverride', []).factory('$exceptionHandler', function () {
    return function (exception, cause) {
        Bugsnag.notifyException(exception, {diagnostics: {cause: cause}});
    };
});
angular.module('FlexyBeautyApp.controllers', []);//Declare controllers
angular.module('FlexyBeautyApp.services', []);//Declare services
angular.module('FlexyBeautyApp.directives', []);//Declare directives

angular.element(function () {
    angular.bootstrap(document, ['FlexyBeautyApp'], {strictDi: true});
});



// WEBPACK FOOTER //
// ./js/app.js